var _style, _g, _g2, _defs, _polygon, _defs2, _path, _defs3, _polygon2, _defs4, _rect, _polygon3, _defs5, _polygon4, _path2, _path3, _defs6, _polygon5, _defs7, _polygon6, _path4, _defs8, _rect2, _polygon7, _defs9, _polygon8, _defs10, _polygon9, _defs11, _polygon10, _defs12, _polygon11, _feBlend, _g3, _path5, _defs13, _polygon12, _path6, _polygon13, _path7, _defs14, _polygon14, _path8, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCremCarrera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:#2E2E2E;}\n\t.st3{display:inline;opacity:0.25;}\n\t.st4{fill:none;stroke:#808080;stroke-miterlimit:10;}\n\t.st5{clip-path:url(#SVGID_2_);fill:url(#SVGID_3_);}\n\t.st6{clip-path:url(#SVGID_5_);fill:url(#SVGID_6_);}\n\t.st7{clip-path:url(#SVGID_8_);fill:url(#SVGID_9_);}\n\t.st8{display:inline;clip-path:url(#SVGID_11_);fill:url(#SVGID_12_);}\n\t.st9{display:inline;clip-path:url(#SVGID_11_);fill:url(#SVGID_13_);}\n\t.st10{display:inline;clip-path:url(#SVGID_11_);}\n\t.st11{clip-path:url(#SVGID_16_);fill:url(#SVGID_17_);}\n\t.st12{fill:#FFFFFF;}\n\t.st13{clip-path:url(#SVGID_20_);fill:url(#SVGID_21_);}\n\t.st14{clip-path:url(#SVGID_24_);fill:url(#SVGID_25_);}\n\t.st15{clip-path:url(#SVGID_24_);}\n\t.st16{clip-path:url(#SVGID_27_);fill:url(#SVGID_28_);}\n\t.st17{clip-path:url(#SVGID_27_);fill:url(#SVGID_29_);}\n\t.st18{clip-path:url(#SVGID_27_);}\n\t.st19{clip-path:url(#SVGID_31_);fill:url(#SVGID_32_);}\n\t.st20{clip-path:url(#SVGID_35_);fill:url(#SVGID_36_);}\n\t.st21{clip-path:url(#SVGID_39_);fill:url(#SVGID_40_);}\n\t.st22{clip-path:url(#SVGID_42_);fill:url(#SVGID_43_);}\n\t.st23{opacity:0.5;}\n\t.st24{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st25{mask:url(#SVGID_44_);}\n\t.st26{fill:#808080;}\n\t.st27{clip-path:url(#SVGID_46_);fill:url(#SVGID_47_);}\n\t.st28{fill:url(#SVGID_48_);}\n\t.st29{fill:#0AAEFF;}\n\t.st30{display:none;fill:#4C4C4C;}\n\t.st31{clip-path:url(#SVGID_50_);fill:url(#SVGID_51_);}\n\t.st32{fill:#4C4C4C;}\n\t.st33{opacity:0.7;fill:#4C4C4C;}\n\t.st34{opacity:0.33;fill:#4C4C4C;}\n\t.st35{fill:#CCCCCC;}\n\t.st36{display:inline;fill:none;stroke:#DB9A00;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st37{fill:none;stroke:#DB9A00;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st2",
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 250,
    cy: 250,
    r: 210
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 0,
    y1: 250,
    x2: 500,
    y2: 250
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 250,
    y1: 500,
    x2: 250,
    y2: 0
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lines"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M121,126.8l97.3-56.2c7.9-4.5,17.2-5.8,25.9-3.4l116,31.1c8.4,2.2,14.2,9.8,14.2,18.5v225.1 c0,9.1-4.9,17.6-12.8,22.2l-95.8,55.6L121,126.8z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.6285,
    y1: 165.4553,
    x2: 271.6203,
    y2: 186.1146
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "383.8,395.5 257.6,439 257.6,162.4 383.8,89.4  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_4_",
    d: "M122.4,125.9c-3.5,2-6,5.8-6,10.4l-0.5,229.7c0,10.9,7.3,20.4,17.8,23.2l121.5,32.8 c3.3,0.9,6.6,0.3,9.3-1.3c1.5-0.9,7.4-4.3,8.9-5.1c3.5-2,6-5.8,6-10.3l0.5-229.7c0-10.9-7.3-20.4-17.8-23.2l-121.5-32.8 c-3.2-0.9-6.3-0.4-8.9,1.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_4_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 278.9484,
    y1: 270.7003,
    x2: 121.8368,
    y2: 270.7003
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C4C4C"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M122.4,125.9c-3.5,2-6,5.8-6,10.4l-0.5,229.7c0,10.9,7.3,20.4,17.8,23.2l121.5,32.8c3.3,0.9,6.6,0.3,9.3-1.3 c1.5-0.9,7.4-4.3,8.9-5.1c3.5-2,6-5.8,6-10.3l0.5-229.7c0-10.9-7.3-20.4-17.8-23.2l-121.5-32.8c-3.2-0.9-6.3-0.4-8.9,1.1"
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "M262,152.2l-121.5-32.8c-3.2-0.9-6.3-0.4-8.9,1.1l-9.2,5.3c0,0,0,0,0,0c2.6-1.5,5.9-2.1,9.1-1.2L253,157.5 c10.5,2.8,17.8,12.4,17.8,23.2l-0.5,229.7c0,4.4-2.4,8.1-5.7,10.2c1.7-1,7.3-4.2,8.8-5.1c3.5-2,6-5.8,6-10.3l0.5-229.7 C279.8,164.6,272.5,155.1,262,152.2z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible",
      fill: "#808080"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 217.5895,
    y1: 194.3603,
    x2: 230.105,
    y2: 214.2622
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "301.8,438.9 253.2,438.9 253.2,168.4 301.8,140.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_10_",
    points: "207.8,388.9 131.5,368.4 131.5,241.4 207.8,262  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_10_",
    style: {
      display: "inline",
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_11_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_10_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 147.6512,
    y1: 306.5006,
    x2: 160.5694,
    y2: 306.5006
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 143.7,
    y: 229.3,
    className: "st8",
    width: 74.4,
    height: 154.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 187.7851,
    y1: 247.4615,
    x2: 172.6023,
    y2: 349.3825
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C4C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C4C4C",
      stopOpacity: 0
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "258.1,230.6 258.1,357.3 103.6,357.3 103.6,230.6  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_14_",
    d: "M187.3,309.4l-13.5,7.8c-2.2,1.3-4.8,1.6-7.2,0.9l-21.5-5.8c-1.9-0.5-3.3-2.3-3.3-4.3l0.6-5.9 l47.8-3.1l-0.7,6.4C189.5,307.2,188.7,308.6,187.3,309.4z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 175.3743,
    y1: 309.0385,
    x2: 145.9444,
    y2: 310.3612
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_14_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_15_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_14_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 170.8647,
    y1: 270.4996,
    x2: 176.9127,
    y2: 271.0813
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "193.2,323.6 166.2,323.6 174.2,219.9 201.2,219.9  "
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M187.9,303.9l-13.5,7.8c-2.2,1.3-4.8,1.6-7.2,0.9l-21.5-5.8c-1.9-0.5-3.5-2.1-3.3-4.7 c0.1-1.2,0.8-2.1,1.7-2.6s6.3-3.6,6.3-3.6l39.7,4.1C190.1,301.7,189.3,303.1,187.9,303.9z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M147,292.3l-0.9,9.4c0,1.7,1.2,3.2,2.8,3.7l18.3,4.9c2.1,0.6,4.3,0.3,6.1-0.8l11.5-6.7c1.2-0.7,1.9-1.9,1.9-3.3l0.9-8.6 L147,292.3z"
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_18_",
    d: "M189.4,290.4l-13.5,7.8c-2.2,1.3-4.8,1.6-7.2,0.9l-21.5-5.8c-1.9-0.5-3.3-2.3-3.3-4.3l8-73.7l19.1-11.1 l28.6,7.7l-8,74.5C191.6,288.2,190.7,289.6,189.4,290.4z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.1474,
    y1: 253.1659,
    x2: 148.8076,
    y2: 249.4461
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_18_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_19_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_18_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 172.9289,
    y1: 251.4947,
    x2: 178.977,
    y2: 252.0764
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "195.3,304.6 168.3,304.6 176.3,200.9 203.3,200.9  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_22_",
    d: "M212,316.1l-13.5,7.8c-2.2,1.3-4.8,1.6-7.2,0.9l-7.6-2c-1.9-0.5-3.3-2.3-3.3-4.3l8-73.7l19.1-11.1 l14.7,3.9l-8,74.5C214.2,313.8,213.4,315.3,212,316.1z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.9768,
    y1: 279.4075,
    x2: 187.0526,
    y2: 277.9209
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_22_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_23_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_22_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 196.3348,
    y1: 283.1569,
    x2: 202.3899,
    y2: 283.6599
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080"
    }
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "218.3,336 191.3,336 199.3,232.4 226.3,232.4  "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M213.7,300.2l-13.5,7.8c-2.2,1.3-4.8,1.6-7.2,0.9l-7.6-2c-1.9-0.5-3.3-2.2-3.3-4.2l-1.7,15.8 c0,2,1.4,3.8,3.3,4.3l7.6,2c2.4,0.7,5,0.3,7.2-0.9l13.5-7.8c1.4-0.8,2.2-2.3,2.2-3.9l1.6-15 C215.6,298.5,214.8,299.6,213.7,300.2z"
  }))))), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_26_",
    points: "207.8,388.9 131.5,368.4 131.5,241.4 207.8,262  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_26_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_27_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_26_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 147.6512,
    y1: 306.5006,
    x2: 160.5694,
    y2: 306.5006
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 143.7,
    y: 229.3,
    className: "st16",
    width: 74.4,
    height: 154.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 187.7851,
    y1: 247.4615,
    x2: 172.6023,
    y2: 349.3825
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C4C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C4C4C",
      stopOpacity: 0
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "258.1,230.6 258.1,357.3 103.6,357.3 103.6,230.6  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_30_",
    d: "M187.3,309.4l-13.5,7.8c-2.2,1.3-4.8,1.6-7.2,0.9l-21.5-5.8c-1.9-0.5-3.3-2.3-3.3-4.3l2.5-23.4 l47.8-3.1l-2.6,23.9C189.5,307.2,188.7,308.6,187.3,309.4z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_30_",
    style: {
      overflow: "visible",
      fill: "#4C4C4C"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_31_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_30_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 170.8647,
    y1: 270.4996,
    x2: 176.9127,
    y2: 271.0813
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "193.2,323.6 166.2,323.6 174.2,219.9 201.2,219.9  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_33_",
    d: "M189,293.6l-13.5,7.8c-2.2,1.3-4.8,1.6-7.2,0.9l-21.5-5.8c-1.9-0.5-3.3-2.3-3.3-4.3l8-73.7l19.1-11.1 l28.6,7.7l-8,74.5C191.2,291.3,190.4,292.8,189,293.6z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 180.8068,
    y1: 256.3009,
    x2: 148.4671,
    y2: 252.5811
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_33_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_34_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_35_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_33_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 172.9289,
    y1: 251.4947,
    x2: 178.977,
    y2: 252.0764
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080"
    }
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "195.3,304.6 168.3,304.6 176.3,200.9 203.3,200.9  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_37_",
    d: "M212,316.1l-13.5,7.8c-2.2,1.3-4.8,1.6-7.2,0.9l-7.6-2c-1.9-0.5-3.3-2.3-3.3-4.3l8-73.7l19.1-11.1 l14.7,3.9l-8,74.5C214.2,313.8,213.4,315.3,212,316.1z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.9768,
    y1: 279.4075,
    x2: 187.0526,
    y2: 277.9209
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_37_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_38_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_39_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_37_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 196.3348,
    y1: 283.1569,
    x2: 202.3899,
    y2: 283.6599
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080"
    }
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "218.3,336 191.3,336 199.3,232.4 226.3,232.4  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_41_",
    d: "M213.7,300.2l-13.5,7.8c-2.2,1.3-4.8,1.6-7.2,0.9l-7.6-2c-1.9-0.5-3.3-2.2-3.3-4.2l-1.7,15.8 c0,2,1.4,3.8,3.3,4.3l7.6,2c2.4,0.7,5,0.3,7.2-0.9l13.5-7.8c1.4-0.8,2.2-2.3,2.2-3.9l1.6-15 C215.6,298.5,214.8,299.6,213.7,300.2z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_41_",
    style: {
      overflow: "visible",
      fill: "#4C4C4C"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_42_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_41_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 197.1835,
    y1: 280.5646,
    x2: 203.2316,
    y2: 281.1463
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "219.5,333.6 192.5,333.6 200.5,230 227.5,230  "
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 108.5,
    y: 139.3,
    width: 109.9,
    height: 149.5
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 108.5,
    y: 139.3,
    width: 109.9,
    height: 149.5,
    id: "SVGID_44_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st24"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 115,
    height: 154,
    xlinkHref: "6FAF16AA07DEB0B6.jpg",
    transform: "matrix(1 0 0 1 106 137)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.6,288.4l-76.7-20.8c-9.1-2.5-15.3-10.7-15.3-20v-94.1c0-9.3,8.8-16,17.8-13.6l76.7,20.8c9.1,2.5,15.3,10.7,15.3,20 v94.1C218.4,284,209.6,290.8,200.6,288.4z"
  })))), /*#__PURE__*/React.createElement("g", null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M195.4,163.6L122,143.9c-1.4-0.4-2.9-0.4-4.2,0c-1.4,0.4-7.1,1.9-8.5,2.4c-2.9,1-5.1,3.5-5.4,6.8l-9.3,89 c-0.5,4.9,2.6,9.4,7.4,10.7l73.4,19.7c1.7,0.5,3.4,0.1,5-0.3c1.1-0.3,5.8-1.5,8-2.3c2.6-1,4.9-3.6,5.2-6.6l9.3-89 C203.3,169.4,200.2,164.9,195.4,163.6z"
  })), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_45_",
    d: "M195.4,163.6L122,143.9c-1.4-0.4-2.9-0.4-4.2,0c-1.4,0.4-7.1,1.9-8.5,2.4c-0.1,0-0.1,0.1-0.2,0.1 c1.5-0.5,3.1-0.7,4.8-0.2l73.4,19.7c4.8,1.3,7.9,5.8,7.4,10.7l-9.3,89c-0.3,3.1-2.4,5.6-5.1,6.6c0,0,0,0,0,0 c1.1-0.3,5.8-1.5,8-2.3c2.6-1,4.9-3.6,5.2-6.6l9.3-89C203.3,169.4,200.2,164.9,195.4,163.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_46_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_45_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 166.4365,
    y1: 178.1854,
    x2: 171.3696,
    y2: 188.4556,
    gradientTransform: "matrix(0.9952 9.830004e-02 -9.830004e-02 0.9952 30.1032 -17.256)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "210.6,295.9 162.3,291.2 176,175.2 227,152.1  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 167.4621,
    y1: 215.0987,
    x2: 14.4826,
    y2: 176.3075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C4C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M175.3,272.4l-73.4-19.7c-4.8-1.3-7.9-5.8-7.4-10.7l9.3-89c0.5-4.9,5.3-8.2,10-6.9l73.4,19.7 c4.8,1.3,7.9,5.8,7.4,10.7l-9.3,89C184.8,270.4,180,273.7,175.3,272.4z"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "177.2,248.3 104.2,228.7 110.9,164.7 184,184.2  "
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M207.8,391l-35.6-9.5c-8-2.1-16.5-1-23.6,3.1c0,0-7.2,4.2-10.2,5.9c-10.2,5.6-11.6,16.8,3.9,21 c12.9,3.5,22.8,2.7,32,1.3c13.7,4.8,28.2,3.2,33.5-3.6V391z"
  })), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_49_",
    d: "M207.8,369l-39.1-10.5c-8.8-2.3-18.1-1.1-25.9,3.4c0,0-7.9,4.7-11.2,6.5c-5.5,3-7.5,7.4-6.9,11.7 c2.3,14.9,6.2,27.2,20.5,33.1c20.9,8.6,44.3,5.1,62.6-4V369z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_49_",
    style: {
      overflow: "visible",
      fill: "#4C4C4C"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_50_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_49_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 206.9837,
    y1: 405.8675,
    x2: 176.638,
    y2: 407.2314
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "173.1,432.6 207.8,428.2 207.8,380.6 171.1,385.2  "
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M207.8,369l-39.1-10.5c-8.8-2.3-18.1-1.1-25.9,3.4c0,0-7.9,4.6-11.2,6.5c-10.1,5.7-9.9,16.8,13.5,24.5 c22.8,7.5,47.4,5.7,62.8-4V369z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "338.1,105.8 220.2,73.8 160.6,108.8 278.6,140.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "160.6,108.8 220.2,73.8 220.2,36.7 160.6,71.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "207.8,121.6 267.3,86.6 267.3,49.5 207.8,84.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "231.4,128 290.9,93 290.9,55.9 231.4,90.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "255,134.4 314.5,99.4 314.5,62.3 255,97.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "278.6,140.8 338.1,105.8 338.1,68.7 278.6,103.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "160.6,71.7 278.6,103.7 278.6,140.8 160.6,108.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.1,68.7 220.2,36.7 160.6,71.7 278.6,103.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M278.6,140.8c0,0,14.3,0,22,0c10.6,0,20.9,7.2,20.9,18.7c0,9.9,0,21.1,0,21.1l53-30.5c0,0,0-20,0-33.4 c0-11-5.1-16-14.2-18.5c-8.6-2.3-22.2-5.9-22.2-5.9v13.5L278.6,140.8z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "H",
    className: "st0"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st36",
    x1: 259.6,
    y1: -32.7,
    x2: 259.6,
    y2: 584.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st36",
    x1: 107.1,
    y1: -71.8,
    x2: 107.1,
    y2: 545.3
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st37",
    x1: -7,
    y1: 562.8,
    x2: 584.4,
    y2: 221.4
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st37",
    x1: -127.7,
    y1: 510.9,
    x2: 463.7,
    y2: 169.5
  })), /*#__PURE__*/React.createElement("line", {
    className: "st36",
    x1: -881.4,
    y1: 103.2,
    x2: 958.9,
    y2: 596.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st36",
    x1: -788.5,
    y1: -108.5,
    x2: 1051.7,
    y2: 384.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st36",
    x1: 269.8,
    y1: -22.3,
    x2: 269.8,
    y2: 594.8
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st37",
    x1: 20.6,
    y1: 359.7,
    x2: 612,
    y2: 18.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st37",
    x1: -103.9,
    y1: 260.6,
    x2: 487.5,
    y2: -80.8
  })), /*#__PURE__*/React.createElement("line", {
    className: "st36",
    x1: -760,
    y1: -220.5,
    x2: 1080.3,
    y2: 272.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st36",
    x1: -807.4,
    y1: -91.7,
    x2: 1032.8,
    y2: 401.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st36",
    x1: -868.6,
    y1: 24.5,
    x2: 971.6,
    y2: 517.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st36",
    x1: 197.8,
    y1: -44.9,
    x2: 197.8,
    y2: 572.2
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_5",
    className: "st0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCremCarrera);
export default __webpack_public_path__ + "static/media/CremCarrera.71eaec990f2f8cb258819502162a8a2d.svg";
export { ForwardRef as ReactComponent };